import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import variables from "../../constants/assets/variables";
import { capitalizeFirstLetter } from "../../utils";
import LaunchReleaseModal from "./LaunchReleaseModal.js";
const allActions = ["view", "edit", "launch", "download apk"];
const ActionBarAppReleasesList = ({
  handleBlur,
  right,
  top,
  appReleaseId,
  appReleaseVersion,
  downloadAppApks,
  activeAppRelease,
  permissions,
  allMenuActions,
}) => {
  const history = useHistory();
  const [launchModal, setLaunchModal] = useState();
  const handleActionClick = (action, appReleaseId) => {
    if (action == "view" || action == "edit") {
      history.push(
        `/driver-app-releases/actions?type=${action}&id=${appReleaseId}&version=${appReleaseVersion}`
      );
    } else if (action == "launch") {
      setLaunchModal(true);
    } else if (action == "download apk") {
      downloadAppApks(appReleaseId).then((res) => {
        res && window.open(res.download_url);
      });
    }
  };
  const handleModalClose = () => {
    setLaunchModal(false);
  };
  const isActionAllowed = (action) => {
    switch (action) {
      case "edit":
        return allMenuActions[permissions.UPDATE];
      case "launch":
        return allMenuActions[permissions.LAUNCH];
      default:
        return true;
    }
  };
  useEffect(() => {
    if (right && top) {
      document.getElementById("actionsBox").style.right = right + "px";
      document.getElementById("actionsBox").style.top = top + "px";
      document.getElementById("layer-mask").style.opacity = 1;
    }
  }, [right, top]);
  return (
    <LayerMask id="layer-mask" onClick={handleBlur}>
      {" "}
      <AppReleasesActions onClick={(e) => e.stopPropagation()} id="actionsBox">
        {" "}
        {allActions.map((action, index) => {
          return (
            isActionAllowed(action) && (
              <li
                onClick={() => handleActionClick(action, appReleaseId)}
                key={index}
              >
                {" "}
                {capitalizeFirstLetter(action.split("_").join(" "))}{" "}
              </li>
            )
          );
        })}{" "}
      </AppReleasesActions>{" "}
      {launchModal && (
        <LaunchReleaseModal
          appVersion={appReleaseVersion}
          appReleaseId={appReleaseId}
          handleModalClose={handleModalClose}
          activeAppRelease={activeAppRelease}
        />
      )}
    </LayerMask>
  );
};
const LayerMask = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  opacity: 0;
`;
const AppReleasesActions = styled.ul`
  list-style-type: none;
  position: absolute;
  background: #fff;
  border: 0.5px solid ${variables.grey100};
  padding: unset;
  max-width: 150px;
  border-radius: 8px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  li {
    padding: 8px;
    cursor: pointer;
    &:not(:last-child) {
      border-bottom: 1px solid ${variables.grey100};
    }
  }
`;
export default ActionBarAppReleasesList;
